import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import anime from 'animejs';
import useRoleUserService from '@/services/RoleUserService';
import useColorService from '@/services/ColorService';

type Props = SetupProps<typeof OrganizationModalCreatorTransferSetupService.props>

export default class OrganizationModalCreatorTransferSetupService extends BaseSetupService<Props> {
	static readonly props = {};

	private readonly state = reactive({
		hasOnlyCreatorOnCreated: false,
		hasTriedToGoNext: false,
	});

	get hasOnlyCreatorOnCreated () { return this.state.hasOnlyCreatorOnCreated; }
	get hasTriedToGoNext () { return this.state.hasTriedToGoNext; }

	get userRolesWithoutCreator () {
		return this.self.roleUsers.filter(x => x?.organizationRole?.name !== 'Créateur');
	}

	get creatorRole () {
		return this.self.roleUsers.filter(x => x?.organizationRole?.name === 'Créateur').first();
	}

	get userRoles () { return this.self.roleUsers; }
	set userRoles (roles) { this.self.setRoles(roles); }


	constructor (props?: Props) {
		super(props);
	}

	protected onMounted () {
		this.state.hasOnlyCreatorOnCreated = !this.userRolesWithoutCreator.length;
	}


	swapColor (color?: string) {
		if (color) {
			return useColorService().swapColor(color);
		}
	}

	defineNewCreator () {
		if (!this.creatorRole?.organizationRole?.id) return;

		if (!this.userRolesWithoutCreator.length) {
			if (this.state.hasTriedToGoNext) {
				this.animateAlert();
			}
			this.state.hasTriedToGoNext = true;
			return;
		}

		useRoleUserService().promptUserSelectAsync(this.creatorRole.organizationRole.id, false, undefined, true);
	}

	animateAlert () {
		anime({
			targets: '.organization-modal-creator-transfer__indicator',
			keyframes: [
				{ translateX: 0 },
				{ translateX: -5 },
				{ translateX: 5 },
				{ translateX: -5 },
				{ translate0: 0 },
			],
			duration: 300,
			easing: 'easeInOutSine',
		});
	}
}
